"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const chatFunctions = __importStar(require("./model/chats"));
class UnreadMessageDetector {
    constructor(chat) {
        this.isUnread = (message) => {
            const isUnreadOnServer = this.unreadClientMessageIds.has(message.clientMessageId) ||
                ("id" in message && this.unreadMessageIds.has(message.id));
            if (!isUnreadOnServer) {
                return false;
            }
            const isPendingBeingMarkedAsRead = this.markAsReadByClientIdPending.has(message.clientMessageId) ||
                ("id" in message && this.markAsReadPending.has(message.id));
            return !isPendingBeingMarkedAsRead;
        };
        this.isUnreadByThem = (message) => {
            if ("id" in message) {
                const isUnreadOnServer = this.unreadByThem.has(message.id);
                if (!isUnreadOnServer) {
                    return false;
                }
                const isPendingBeingMarkedAsRead = this.markAsReadByThemPending.has(message.id) ||
                    this.markAsReadByThemByClientIdPending.has(message.clientMessageId);
                return !isPendingBeingMarkedAsRead;
            }
            else {
                return !this.markAsReadByThemByClientIdPending.has(message.clientMessageId);
            }
        };
        if (chatFunctions.isConfirmedChat(chat)) {
            this.unreadMessageIds = new Set(chat.unreadMessageIds);
            this.unreadClientMessageIds = new Set(chat.unreadClientMessageIds);
            this.markAsReadPending = new Set(chat.markAsReadPending);
            this.markAsReadByClientIdPending = new Set(chat.markAsReadByClientIdPending);
            if (chatFunctions.isDirectChat(chat)) {
                this.unreadByThem = new Set(chat.unreadByThemMessageIds);
                this.markAsReadByThemPending = new Set(chat.markAsReadByThemPendingSync);
                this.markAsReadByThemByClientIdPending = new Set(chat.markAsReadByThemByClientIdPendingSync);
            }
            else {
                this.unreadByThem = new Set(chat.unreadByAnyMessageIds);
                this.markAsReadByThemPending = new Set();
                this.markAsReadByThemByClientIdPending = new Set();
            }
        }
        else {
            this.unreadMessageIds = new Set();
            this.unreadClientMessageIds = new Set();
            this.markAsReadPending = new Set();
            this.markAsReadByClientIdPending = new Set();
            this.unreadByThem = new Set();
            this.markAsReadByThemPending = new Set();
            this.markAsReadByThemByClientIdPending = new Set();
        }
    }
}
exports.default = UnreadMessageDetector;
